import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { fetchTestRecord } from "../../services/dashboard";
import TestInfo from "../../components/dashboard/testInfo";
import TestResult from "../../components/dashboard/testResult";
import Tabs from "../../components/common/tabs";
import DashboardLayout from "../../layout/dashboardLayout";

const DashboardProfileRecord = () => {
  const { id, test } = useParams();

  const [testRecord, setTestRecord] = useState<any>(null);

  useEffect(() => {
    if (id)
      //@ts-ignore
      fetchTestRecord(id, test).then((response) => {
        setTestRecord(response.data);
      });
  }, [id]);

  const tabItems = [
    {
      id: 0,
      title: "اطلاعات آزمایش",
      content: (
        <div>
          <TestInfo data={testRecord} />
        </div>
      ),
    },
    {
      id: 1,
      title: "تحلیل",
      content: (
        <div>
          <TestResult data={testRecord} />
        </div>
      ),
    },
  ];

  return (
    <DashboardLayout>
      <div className="my-10">
        <div className="breadcrumbs text-sm">
          <ul>
            <li>
              <Link to="/dashboard">داشبورد</Link>
            </li>
            <li>
              <Link to="/dashboard-profiles">کاربران بادی‌بان</Link>
            </li>
            <li>
              <Link to={`/dashboard-profiles/${test}`}>پروفایل کاربر</Link>
            </li>

            <li className="font-[900]">آزمایش {testRecord?.id}</li>
          </ul>
        </div>

        {testRecord && <Tabs tabItems={tabItems} />}
      </div>
    </DashboardLayout>
  );
};

export default DashboardProfileRecord;
